export default "__VITE_ASSET__Dh0YmvDy__"